var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdenVentaVer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 178 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ff8e31;}.cls-3{fill:#ed7425;}.cls-4{fill:#d41a1a;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill-opacity:0.39;}.cls-7{fill:#e55a5a;}.cls-8{fill:#fff;}.cls-9{fill:#5d6d7e;}.cls-10{fill:#fece59;}.cls-11{fill:#34495e;}.cls-12,.cls-13{fill:#cee2f2;}.cls-13{opacity:0.02;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.19,23.75l38.74,38.74H99.15a6.56,6.56,0,0,1-6-6Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orden-venta-verPDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 89,
    cy: 89,
    r: 89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.4,114.06,136.18,75.83a2,2,0,0,0-1.36-.56h-.18L121.86,62.5a1.83,1.83,0,0,0-.6-.41L121,62a1.09,1.09,0,0,0-.31-.08h0c-.06,0-.11,0-.16,0h0l-4.23-4.21-9.66-9.66H61.66V61.94H57.5a1.83,1.83,0,0,0-1.35.56,1.91,1.91,0,0,0-.57,1.34V75.27H43.19a1.91,1.91,0,0,0-1.92,1.92v38.17a2,2,0,0,0,.56,1.36l35.6,35.59.25.27h0l.35.35,24.1,24.1A89.08,89.08,0,0,0,174.4,114.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-6",
    className: "cls-4",
    d: "M41.22,25.84A5.42,5.42,0,0,0,36.07,31V139.1a5.66,5.66,0,0,0,5.15,5.15h82.37a5.66,5.66,0,0,0,5.15-5.15V59.3L95.28,25.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8-3",
    className: "cls-6",
    d: "M95,26.64,128.45,60.1H100.13A5.65,5.65,0,0,1,95,55Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-7",
    d: "M95.28,25.84,128.74,59.3H100.43a5.66,5.66,0,0,1-5.15-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    className: "cls-8",
    d: "M71.81,57.1a5.12,5.12,0,0,0-5,6c.43,4.6,3.4,8.34,5.71,12.14.26,1.41-.48,2.79-.53,4.2a98.7,98.7,0,0,1-7.36,24c-4.38,2-9.35,4-11.92,8.36a5.25,5.25,0,0,0,4,7.41c3.12.43,5.44-2.24,7.15-4.48,1.78-2.42,3-5.29,4.43-7.88a102.59,102.59,0,0,1,28.05-7.09c3.89,2.78,8,6.07,13,6.27a5.24,5.24,0,0,0,4.94-5.72c-.19-2.61-2.5-4.44-4.9-4.93-3.87-1.16-8-.52-12-.49a100.55,100.55,0,0,1-20.07-21c.41-4.85,1.23-10.2-1.29-14.61a4.85,4.85,0,0,0-4.3-2.19M72,61.5c.85.16.91,1.43,1.15,2.11a24.45,24.45,0,0,1,.18,4.19c-1-1.89-2.33-3.88-2.1-6.13.27,0,.51-.14.77-.17m4.7,18.88a116,116,0,0,0,15,15.47,111.94,111.94,0,0,0-21.25,5.43,119.43,119.43,0,0,0,6-21.24l.29.34m28.15,18.87c1.75.17,3.77.07,5.17,1.27.13,1.09-1.2,1.25-1.91.86a14.92,14.92,0,0,1-4.2-2.06c.32,0,.63-.06.94-.07M61.08,110.7a14.78,14.78,0,0,1-3.31,4.1c-.42.68-1.57-.58-1-1.11,1.1-1.71,3-2.62,4.7-3.65-.11.22-.23.44-.35.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "106.05 133.57 104.58 135.05 102.85 136.76 102.19 137.43 98.75 133.99 102.6 130.13 106.05 133.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.24,134,83.37,145.84a4.86,4.86,0,0,0-1.44,3.48,4.93,4.93,0,0,0,8.41,3.49l11.87-11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M96.88,135.61h0l-1-1L84,146.51a4,4,0,0,0-1.16,2.81A4,4,0,0,0,84,152.14a.7.7,0,0,0,.49.19.65.65,0,0,0,.48-.2.67.67,0,0,0,0-1,2.6,2.6,0,0,1-.76-1.85,2.54,2.54,0,0,1,.76-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M102.21,140.94l-7-7,.52-.52a1.68,1.68,0,0,1,1.22-.51,1.71,1.71,0,0,1,1.22.5l4.53,4.54a1.68,1.68,0,0,1,.51,1.22,1.7,1.7,0,0,1-.51,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M141.93,116.54a22.29,22.29,0,1,0-22.29,22.28A22.29,22.29,0,0,0,141.93,116.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.64,136.41a19.88,19.88,0,1,1,19.88-19.87A19.87,19.87,0,0,1,119.64,136.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M119.64,134.82a18.29,18.29,0,1,1,18.29-18.28A18.28,18.28,0,0,1,119.64,134.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.16,101.26a1.59,1.59,0,0,1,1.44-.72,15.83,15.83,0,0,1,7.09,2.13,1.62,1.62,0,0,1,.58,2.21,1.6,1.6,0,0,1-2.2.57,12.77,12.77,0,0,0-5.66-1.69,1.6,1.6,0,0,1-1.51-1.7A1.52,1.52,0,0,1,119.16,101.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.51,106.56a1.78,1.78,0,0,1,.32-.35,1.61,1.61,0,0,1,2.27.23,16,16,0,0,1,2.39,16.11,1.61,1.61,0,0,1-3-1.22,12.85,12.85,0,0,0-1.9-12.86A1.61,1.61,0,0,1,129.51,106.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 82.39,
    y: 94.25,
    width: 59.54,
    height: 59.54
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdenVentaVer);
export default __webpack_public_path__ + "static/media/orden-venta-ver.385fe1b244ee75394d2f75bc1d6216ee.svg";
export { ForwardRef as ReactComponent };